import React from "react";
import {withRouter} from "react-router-dom";
import ToastHelper from "../../utils/ToastHelper";
import {
    Card,
    CardBody,
    CardGroup,
    Col,
    Container,
    Form,
    Input,
    InputGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import PasswordChangeService from "../../services/PasswordChangeService";
import UserSessionService from "../../services/UserSessionService";

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);

        this.props.changeHeader("Change Password");
        let username = UserSessionService.getUser().username;

        this.state = {
            username: username,
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            showSuccessPopup: false,
            showConfirmPasswordChangePopup: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.showConfirmPasswordChange = this.showConfirmPasswordChange.bind(this);
        this.showSuccessPopup = this.showSuccessPopup.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    validateForm() {
        return this.state.oldPassword.length > 0 &&
            this.state.newPassword.length > 0 &&
            (this.state.newPassword === this.state.confirmNewPassword);
    }

    handleChange = event => {

        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit(event) {
        if (event.preventDefault) event.preventDefault();

        this.showConfirmPasswordChange();
    }

    changePassword() {

        this.showConfirmPasswordChange();

        PasswordChangeService.changePassword(this.state.username, this.state.oldPassword, this.state.newPassword).then(response => {
            if (response === 'success') {
                this.showSuccessPopup();
            } else {
                ToastHelper.error(response.message);
            }
        });

    }

    showConfirmPasswordChange() {
        this.setState({
            showConfirmPasswordChangePopup: !this.state.showConfirmPasswordChangePopup
        })
    }

    showSuccessPopup() {
        this.setState({
            showSuccessPopup: !this.state.showSuccessPopup
        })
    }

    render() {

        return <div className="app flex-row align-items-center">
            <Container className={"logo-center"}>
                <Row className="justify-content-center">
                    <Col md="8">
                        <CardGroup>
                            <Card className="p-2">
                                <CardBody>
                                    <Form onSubmit={this.handleSubmit}>
                                        <Col>
                                            <Row className="mb-3" style={{paddingRight: "15px", paddingLeft: "15px"}}>
                                                <h4>{"Change Password"}</h4>
                                            </Row>
                                            <hr/>
                                            <InputGroup className="mb-3">
                                                <Input className="form-control input-lg"
                                                       type="password"
                                                       placeholder="Old Password"
                                                       autoComplete="oldPassword"
                                                       id="oldPassword"
                                                       autoFocus
                                                       onChange={this.handleChange}
                                                       value={this.state.oldPassword}/>
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <Input className="form-control input-lg"
                                                       type="password"
                                                       placeholder="New Password"
                                                       id="newPassword"
                                                       autoComplete="newPassword"
                                                       onChange={this.handleChange}
                                                       value={this.state.newPassword}/>
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <Input className="form-control input-lg"
                                                       type="password"
                                                       placeholder="Confirm New Password"
                                                       id="confirmNewPassword"
                                                       autoComplete="confirmNewPassword"
                                                       onChange={this.handleChange}
                                                       value={this.state.confirmNewPassword}/>
                                            </InputGroup>
                                            <Row className="mb-3"
                                                 style={{paddingRight: "15px", paddingLeft: "15px"}}
                                            >
                                                <SFXButtonComponent className="btn btn-lg btn-block btn-primary"
                                                                    disabled={!this.validateForm()}
                                                >Reset Password</SFXButtonComponent>
                                            </Row>
                                        </Col>
                                    </Form>

                                    <Modal isOpen={this.state.showConfirmPasswordChangePopup}
                                           toggle={this.toggle}
                                           className={'modal-danger modal-sd ' + this.props.className}>
                                        <ModalHeader>Password Change</ModalHeader>
                                        <ModalBody>
                                            Are you sure you wish to change your password? You will be required to log
                                            in with your new password.
                                        </ModalBody>
                                        <ModalFooter>
                                            <SFXButtonComponent color="danger"
                                                                onClick={() => this.changePassword()}
                                            >Confirm</SFXButtonComponent>
                                            <SFXButtonComponent color="secondary"
                                                                onClick={() => this.showConfirmPasswordChange()}
                                            >Cancel</SFXButtonComponent>

                                        </ModalFooter>
                                    </Modal>

                                    <Modal isOpen={this.state.showSuccessPopup}
                                           toggle={this.toggle}
                                           className={'modal-danger modal-sd ' + this.props.className}
                                    >
                                        <ModalHeader>Password Change Successful</ModalHeader>
                                        <ModalBody>
                                            Password changed successfully. You will now be required to log in with your
                                            new password.
                                        </ModalBody>
                                        <ModalFooter>
                                            <SFXButtonComponent color="success"
                                                                onClick={() => this.props.history.replace("/logout")}
                                            >Logout</SFXButtonComponent>
                                        </ModalFooter>
                                    </Modal>

                                </CardBody>
                            </Card>
                        </CardGroup>
                    </Col>
                </Row>
            </Container>
        </div>

    }

}

export default withRouter(ChangePassword);